import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, getIdToken } from "firebase/auth";
import { auth } from "../services/firebaseConfig";
import {
  signInWithGoogle,
  signUpWithEmail,
  signInWithEmail,
  signInAnon,
  logout,
} from "../services/firebaseAuthService"; // Import your auth functions

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser , setCurrentUser ] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
  
      if (user) {
        const token = await getIdToken(user); // No force refresh
        setIdToken(token);
  
        // ⏱️ Setup token refresh every 55 mins
        const refreshInterval = setInterval(async () => {
          const refreshedToken = await getIdToken(user, true); // Force refresh
          setIdToken(refreshedToken);
        }, 30 * 60 * 1000); // 55 minutes
  
        // Store interval ID to clear it later
        user.refreshTokenInterval = refreshInterval;
      } else {
        setIdToken(null);
      }
  
      setLoading(false);
    });
  
    // Clean up on unmount
    return () => {
      unsubscribe();
      if (auth.currentUser && auth.currentUser.refreshTokenInterval) {
        clearInterval(auth.currentUser.refreshTokenInterval);
      }
    };
  }, []);

  const value = {
    currentUser ,
    idToken,
    isAuthenticated: !!currentUser ,
    loading,
    signInWithGoogle,
    signUpWithEmail,
    signInWithEmail,
    signInAnon,
    logout,
    isAnonymous: currentUser ? currentUser.isAnonymous : false,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};